<template>
  <v-dialog v-model="dialog" width="920" :fullscreen="$vuetify.breakpoint.smAndDown">
    <template v-slot:activator="{ on }">
      <div class="text-left">
        <v-btn color="accent" dark v-on="on">
          <slot></slot>
        </v-btn>
      </div>
    </template>
    <UserSymptoms
      @user-symptoms-cancel="dialog = false"
      @user-symptoms-added="onSaveData"
      :symptoms.sync="symptoms"
    />
  </v-dialog>
</template>
<script>
import UserSymptoms from "@/components/UserSymptoms";
export default {
  components: {
    UserSymptoms
  },
  methods: {
    onSaveData() {
      this.dialog = false;
      if (
        this.symptoms.condition === "recovered" &&
        this.symptoms.temperaturePoint === undefined
      )
        this.symptoms.temperaturePoint = "NA";
      if (this.symptoms) this.$emit("on-done", this.symptoms);
    }
  },
  props: {
    initialSymptoms: () => ({
      type: Object,
      default: {}
    })
  },
  data: () => ({
    dialog: false,
    symptoms: {} // JSON.parse(JSON.stringify(this.initialSymptoms)) BUG BUG not working
  }),
  watch: {
    dialog: function onChange(val) {
      this.$emit("editing-state-change", val);
    }
  }
};
</script>
